/* eslint-disable */
import React, {PropTypes} from 'react';
import Select from 'react-select';
import $ from 'jquery';

class SelectMeioComunicacaoDenuncia extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
          value: 0,
          limparTela: true
        };
       this.getMeiosConhecimentoDenunciaSelecionada = this.getMeiosConhecimentoDenunciaSelecionada.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        
        if(this.props.limparSelecao && this.state.limparTela){
            this.setState({value: '0', limparTela: false}); 
        }
        
        if(this.props.selecinarId !== nextProps.selecinarId){
            
                this.setState({value: nextProps.selecinarId}); 
        }
 
    }
    componentDidMount() {
        if(!$.isEmptyObject(this.props.selecinarId)){
           this.setState({value: this.props.selecinarId});
        }
     }
    
    getMeiosConhecimentoDenunciaSelecionada(val){
        //console.log('getSituacoesSelecionadas', val);
        
        this.setState({ value: val});
        //console.log('Estrutura selecionada ', this.props.areaTratamento.dado[i]);
        this.props.getMeiosConhecimentoDenunciaSelecionada(val);
    }

 
    render() {
       // //console.log('value', this.state.value)
       
        var lis =  this.props.meiosConhecimento.map(p => ( 
                { value: p.id.toString(), label: p.descricao }
        ));

        return ( 
            <Select multi={this.props.multi} simpleValue  placeholder="Selecione" options={lis} value={this.state.value} onChange={this.getMeiosConhecimentoDenunciaSelecionada} clearable={false} disabled={this.props.disabled} />
            )
    }
}

SelectMeioComunicacaoDenuncia.protoType = {
    filterme: React.PropTypes.func.isRequired,
    meiosConhecimento: React.PropTypes.object.isRequired
}


export default SelectMeioComunicacaoDenuncia;



/** WEBPACK FOOTER **
 ** ./src/components/common/SelectMeioComunicacaoDenuncia.js
 **/